<script>
import { mapState } from "vuex";
import vDatePicker from "v-calendar/lib/components/date-picker.umd";

import moment from "@/utils/moment";
import cycleMixin from "@/mixins/cycleMixin";

export default {
  mixins: [cycleMixin],

  components: {
    vDatePicker
  },

  data() {
    return {
      horizontal: null
    };
  },

  methods: {
    handleResize() {
      this.horizontal = window.innerWidth > 600;
    }
  },

  computed: {
    ...mapState("payable", ["payable"]),

    events: function() {
      return [
        {
          bar: "purple",
          dates: this.payable.orders.map(
            order => order.schedule_event.starts_at
          )
        }
      ];
    }
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<template>
  <div class="cycle-orders">
    <h4>Limpezas agendadas para o ciclo</h4>

    <div class="calendar">
      <v-date-picker
        color="purple"
        :min-date="payable.starts_at"
        :max-date="payable.ends_at"
        :value="null"
        is-inline
        :columns="horizontal ? 2 : 1"
        :masks="{ weekdays: 'WWW' }"
        locale="pt-BR"
        :attributes="events"
      >
      </v-date-picker>
    </div>
  </div>
</template>

<style scoped>
.cycle-orders {
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: #424242;
  text-align: center;
}

.calendar {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.calendar * {
  border-radius: 0;
}

.calendar >>> .vc-title {
  font-weight: 400;
  text-transform: capitalize;
}

.calendar >>> .vc-weekday {
  font-weight: 400;
  text-transform: capitalize;
  font-size: 12px;
}

.calendar >>> .vc-day-content {
  font-weight: 400;
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/CycleComponents/CycleOrders.vue